import { startCase } from "lodash";
import { useSearchParams } from "react-router-dom";

import DynamicObjectOverview from "@/pages/dynamic/list-views/DynamicObjectOverview";

import {
  BoxedContent,
  Header,
  CrossButton,
  Drawer,
} from "@/components/common";

import { handleDrawer } from "@/utils/modal/helpers";

const getObjectName = (payload) => {
  const { objectName } = payload;
  return objectName;
};

const getFilters = (payload) => {
  const { filters } = payload;
  return filters;
};

export default function DynamicListDrawer() {
  const [searchParams, setSearchParams] = useSearchParams();

  const drawers = JSON.parse(searchParams.get("dynamicObjectListDrawers") || null) || [];
  const objectName = drawers.length ? getObjectName(drawers.at(-1)) : null;
  const filters = drawers.length ? getFilters(drawers.at(-1)) : {};

  const handleClose = () => {
    handleDrawer(null, setSearchParams, true, "dynamicObjectListDrawers");
  };

  const isOpen = Boolean(drawers.at(-1));

  if (!isOpen) {
    return null;
  }

  return (
    <Drawer
      isOpen={isOpen}
      className="drawer-border drawer-profile-border"
      onClose={handleClose}
    >
      <BoxedContent className="profile-drawer mobile-responsive-drawer dynamic-drawer">
        <Header
          leftContent={startCase(objectName)}
          rightContent={(
            <div className="d-flex align-items-center">
              <CrossButton onClick={handleClose} />
            </div>
          )}
        />
        <DynamicObjectOverview
          showTableOnly
          objectName={objectName}
          filters={filters}
          showPagination={false}
          defaultCanSort={false}
        />
      </BoxedContent>
    </Drawer>
  );
}
